module.exports = __webpack_public_path__ + "img/8Y6.7f63074d.png";